import { SymbolLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const poiLayer: SymbolLayerSpecification = {
  id: LayerNameEnum.POI,
  type: 'symbol',
  source: SourceNameEnum.POIS,
  filter: ['==', 'featureType', FeatureTypeEnum.POI_ICON],
  layout: {
    'icon-image': ['get', 'icon'],
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-anchor': 'center',
    'icon-pitch-alignment': 'viewport',
    'icon-rotation-alignment': 'viewport',
    'symbol-z-order': 'source',
  },
};
